// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"450":"885e15d4","482":"06b46d1c","934":"007e1b79","7076":"3f71f317","8926":"294eab77"}[chunkId] + ".chunk.css";
};